import service from '.';
/**
 * ArticleTypeRes，更新文章类型
 */
export interface ArticleTypeRes {
    /**
     * 文章名称
     */
    articleName?: string;
    /**
     * agentId
     */
    agentId?: string;
    /**
     * 备注
     */
    remark?: string;
    /**
     * 空间id
     */
    spaceId?: string;
    /**
     * 文章类型id
     */
    typeId: string;
    /**
     * 文章类型名称
     */
    typeName?: string;
    [property: string]: any;
}

export const articleTypeApi = {
  list: (data: { pageIndex: number; pageSize: number; typeName?: string }) => {
    return service.post('/article/article-type-page', data);
  },
  create: (data: Partial<ArticleTypeRes>) => {
    return service.post('/article/article-type-create', data);
  },
  delete: (typeIds: string[]) => {
    return service.post('/article/article-type-delete', { typeIds });
  },
  save: (data: Partial<ArticleTypeRes>) => {
    return service.post('/article/article-type-update', data);
  },
};
